var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"my-2"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.$t('ros.stepX', [_vm.stepNumber])))]),_vm._v(": "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"mt-2 text-body-2"},[_vm._t("content")],2)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }